import { Component, OnInit } from '@angular/core';
import {CuentasService, NavigationService, PermisosService, SpinnerService} from '../../../../services';
import {UsuarioAgro} from '../usuarios.component';
import {ActivatedRoute, Route, Router} from '@angular/router';
import {PATH_COLABORADOR_DETAIL, PATH_CUENTAS, PATH_DETALLE_USUARIO_AGRO, PATH_NEGOCIOS} from '../../../../navigation/navigation.module';
import {Location} from '@angular/common';

@Component({
  selector: 'app-usuario-agro-detail',
  templateUrl: './usuario-agro-detail.component.html',
  styleUrls: ['./usuario-agro-detail.component.scss']
})
export class UsuarioAgroDetailComponent implements OnInit {
  usuario: UsuarioAgro;

  constructor(
    private navigationService: NavigationService,
    private router: Router,
    private route: ActivatedRoute,
    private cuentasService: CuentasService,
    private location: Location,
    private spinnerService: SpinnerService,
    private permisosService: PermisosService
  ) {
    permisosService.verificarAccesoDeURL();
  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      const id = this.route.snapshot.params['id'];
      this.spinnerService.setSoftSpinnerShowFlag(true);
      this.cuentasService.agroGetUser(id).subscribe(x => {
        this.usuario = x as UsuarioAgro;
        this.usuario.Estado = ParseEstadoAgro(this.usuario.Estado);
        this.spinnerService.setSoftSpinnerShowFlag(false);
        console.log(this.usuario);
      }, err => this.spinnerService.setSoftSpinnerShowFlag(false));
    });
  }

  navigateBack() {
    if (this.navigationService.isBackBtnReady()) {
      this.location.back();
    } else {
      this.router.navigateByUrl('/' + PATH_CUENTAS + '/usuarios');
    }
  }

  goToColaborador(i: number): void {
    this.router.navigateByUrl(`${PATH_COLABORADOR_DETAIL}/${i}`);
  }

}

export function ParseEstadoAgro(estado: string): string {
  const dictionary = [
    {Rol: 'INACTIVE', Parse: 'Inactivo'},
    {Rol: 'ACTIVE', Parse: 'Activo'},
    {Rol: 'PENDING_OF_APPROVAL', Parse: 'Pendiente de Aprobación'},
    {Rol: 'UNKNOWN', Parse: 'Desconocido'},
    {Rol: 'PENDING_QUIEN_ES_QUIEN_APPROVAL', Parse: 'Pendiente de aprobación por el Admin'},
    {Rol: 'REDIRECTED_TO_COLABORADORES_APPROVAL', Parse: 'Redirigido a validar por Colaboradores'},
    {Rol: 'PENDING_EMAIL_VALIDATION', Parse: 'Validación de email pendiente'},
  ]
  return dictionary.find(y => y.Rol === estado).Parse;
}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/cuentas/usuarios/usuario-agro-detail/usuario-agro-detail.component.ts